import React from 'react'

export function Container(props) {

    let className = ['container'];
    if(props.className) className.push(props.className)
    className = className.join(' ')

    return (
        <div className={className}>{props.children}</div>
    )
}
